// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scroll-300 {
  height: 260px;
  overflow-y: scroll;
  font-weight: 400;
  font-size: 12px;
  color: #9dbcc1; }

.scroll-200 {
  max-height: 200px;
  overflow-y: scroll; }

.dropdown-option {
  padding: 12px 16px;
  border-radius: 0.375rem;
  min-height: 24px;
  cursor: pointer; }
  .dropdown-option:hover {
    background-color: grey; }

.modal-90w {
  --bs-modal-bg: none !important;
  --bs-modal-border-radius: 30px !important; }
  @media screen and (min-width: 576px) {
    .modal-90w {
      --bs-modal-width: 500px !important; } }
  @media screen and (min-width: 768px) {
    .modal-90w {
      --bs-modal-width: 550px !important; } }
  @media screen and (min-width: 992px) {
    .modal-90w {
      --bs-modal-width: 650px !important; } }
  @media screen and (min-width: 1200px) {
    .modal-90w {
      --bs-modal-width: 775px !important; } }
  .modal-90w small {
    color: #a6c6cc !important; }
  .modal-90w .error {
    color: rgba(252, 67, 67, 0.959) !important; }
  .modal-90w .form-text {
    font-weight: 400;
    font-size: 10px; }
  .modal-90w .modal-content {
    background-image: linear-gradient(to top left, #174454 0%, #192f43 50%, #27536d 100%);
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.25);
    font-family: Inter !important; }
  .modal-90w .modal-header,
  .modal-90w .modal-body,
  .modal-90w .modal-footer {
    background: none;
    border: none;
    padding-left: 30px;
    padding-right: 30px; }
  .modal-90w .container {
    margin-top: 10px;
    padding: 0; }
  .modal-90w .form-label {
    font-family: "Bai Jamjuree";
    font-style: normal;
    font-weight: 400;
    font-size: 14px; }
  .modal-90w .form-control {
    font-size: 14px; }
  .modal-90w input:not([type="checkbox"]):not([type="radio"]) {
    padding: 6px 15px; }
  .modal-90w .modal-header {
    font-family: "Bai Jamjuree";
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    color: #31a6c2;
    border-top-left-radius: var(--bs-modal-border-radius);
    border-top-right-radius: var(--bs-modal-border-radius);
    padding-top: 10px;
    padding-bottom: 10px;
    background: rgba(255, 255, 255, 0.034); }
  .modal-90w .modal-min-height {
    height: 300px !important; }
  .modal-90w .modal-body {
    padding-top: 0.2rem;
    padding-bottom: 0;
    /* This will affect the entire document's scrollbar */ }
    .modal-90w .modal-body ::-webkit-scrollbar {
      width: 10px;
      /* width of the entire scrollbar */ }
    .modal-90w .modal-body ::-webkit-scrollbar-track {
      background: transparent;
      /* color of the tracking area */ }
    .modal-90w .modal-body ::-webkit-scrollbar-thumb {
      background-color: #bcc7c8;
      /* color of the scroll thumb */
      border-radius: 20px;
      /* roundness of the scroll thumb */ }
    .modal-90w .modal-body .tab-content {
      height: 300px !important;
      background: #0c141dab !important;
      padding: 20px;
      border-radius: 15px;
      overflow: hidden; }
    .modal-90w .modal-body .tab-group {
      background: transparent;
      background-image: none !important;
      border: none !important;
      font-family: "Bai Jamjuree" !important;
      font-style: normal;
      justify-content: center; }
      .modal-90w .modal-body .tab-group .nav-item {
        flex-basis: content;
        flex-grow: 0;
        margin: 0 10px; }
      .modal-90w .modal-body .tab-group .tab-button {
        border-radius: 0 !important;
        display: block;
        border: none !important;
        background: transparent;
        font-family: "Bai Jamjuree";
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        color: white !important;
        letter-spacing: 0.57px; }
        .modal-90w .modal-body .tab-group .tab-button.active, .modal-90w .modal-body .tab-group .tab-button:hover {
          text-shadow: 0 0 1px white, 0 0 1px white, 0 0 1px white;
          text-shadow: 0px 0px 1px white;
          color: white !important;
          --bs-nav-tabs-link-active-bg: #295f7f00 !important;
          background-image: none !important;
          background: transparent;
          border-bottom: 2px solid #44d5cd !important; }
  .modal-90w .modal-footer {
    box-sizing: border-box;
    margin-top: 10px;
    margin-bottom: 15px;
    padding-top: 0;
    padding-bottom: 0; }
    .modal-90w .modal-footer * {
      margin-right: 0;
      margin-left: 0; }
  .modal-90w .modal-msg,
  .modal-90w .modal-error-msg {
    font-family: "Bai Jamjuree";
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    color: #587e89; }
  .modal-90w .close-btn {
    color: #329aa3;
    font-family: MyriadPro;
    letter-spacing: 0.05em;
    font-weight: 700;
    font-size: 14px;
    background: rgba(0, 0, 0, 0);
    padding: 5px 20px;
    min-width: 75px;
    border: 1px solid #329ea0;
    border-radius: 8px; }
    .modal-90w .close-btn:hover {
      border: 1px solid #3f9a92;
      color: #3f9a92 !important;
      background: #303836 !important; }
  .modal-90w .confirm-btn {
    min-width: 75px;
    font-family: MyriadPro;
    letter-spacing: 0.05em;
    font-weight: 700;
    font-size: 14px;
    color: #23434b;
    background: #4bc0d3;
    padding: 5px 20px;
    border-radius: 8px; }
    .modal-90w .confirm-btn:enabled {
      color: #23434b; }
    .modal-90w .confirm-btn:hover {
      background: #4bc0d3 !important;
      color: #fefefe; }
    .modal-90w .confirm-btn:disabled {
      background: #5c666f;
      color: #202932; }
  .modal-90w .task-fee {
    font-family: "Bai Jamjuree";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #9dbcc1; }
  .modal-90w .image-info {
    font-family: "Bai Jamjuree";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    color: #9dbcc1; }
    .modal-90w .image-info .info-title {
      display: grid;
      grid-template-columns: 1fr 1fr 2fr;
      font-weight: 400;
      font-size: 14px; }
      .modal-90w .image-info .info-title .label-text {
        text-align: start; }
    .modal-90w .image-info .info-row {
      display: grid;
      grid-template-columns: 1fr 1fr 2fr;
      font-weight: 400;
      font-size: 14px;
      color: #72e9d9; }
      .modal-90w .image-info .info-row .address {
        color: #9dbcc1;
        transition: all 0.3s ease-in-out; }
        .modal-90w .image-info .info-row .address:hover {
          color: white; }

.modal-btn {
  cursor: pointer;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 12px; }

.logs-btn {
  color: #23434b;
  font-weight: 700;
  background-image: linear-gradient(90deg, #79e3df 0%, #37a0d2 100%) !important;
  padding: 5px 20px;
  min-width: 120px; }
  .logs-btn:hover {
    color: white; }

.proof-info-label {
  font-family: "Bai Jamjuree";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: #9dbcc1; }

.payment-target {
  color: #9dbcc1 !important; }

.checkbox-label, .new-proof-checkbox-label {
  font-family: "Bai Jamjuree";
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  color: #a6c6cc;
  display: flex;
  align-items: center; }

.new-proof-checkbox-label {
  font-size: 12px; }

.badge {
  background-color: #2a4953 !important;
  font-size: 12px;
  font-weight: 400 !important;
  margin-left: 5px;
  margin-right: 5px; }

.tooltip {
  --bs-tooltip-bg: #111c26 !important;
  --bs-tooltip-padding-y: 10px !important;
  --bs-tooltip-padding-x: 10px !important; }

.topup-button {
  border: 1px solid #72e9d9;
  border-radius: 5px;
  padding: 2px 8px;
  color: #72e9d9;
  display: flex;
  align-items: center;
  justify-content: center; }
  .topup-button:hover {
    color: #72e9d9;
    background: #2f4743; }

.highlight {
  color: #ffffff;
  background: #43c0d3;
  border-radius: 5px; }

.reset-btn {
  color: #8edef5; }

.subscription-info .form-label {
  color: white !important;
  font-size: 15px;
  width: 30%; }

.subscription-info .form-text {
  color: #a6c6cc !important;
  font-size: 14px; }

.subscription-info .form-select {
  width: auto !important;
  padding-top: 0.1rem !important;
  padding-bottom: 0.1rem !important;
  font-size: 12px !important; }
`, "",{"version":3,"sources":["webpack://./src/modals/style.scss"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EAEf,cAAc,EAAA;;AAGhB;EACE,iBAAiB;EACjB,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe,EAAA;EAJjB;IAMI,sBAAsB,EAAA;;AAI1B;EACE,8BAAc;EACd,yCAAyB,EAAA;EAEzB;IAJF;MAKI,kCAAiB,EAAA,EA2PpB;EAzPC;IAPF;MAQI,kCAAiB,EAAA,EAwPpB;EAtPC;IAVF;MAWI,kCAAiB,EAAA,EAqPpB;EAnPC;IAbF;MAcI,kCAAiB,EAAA,EAkPpB;EAhQD;IAkBI,yBAAyB,EAAA;EAlB7B;IAqBI,0CAA0C,EAAA;EArB9C;IAwBI,gBAAgB;IAChB,eAAe,EAAA;EAzBnB;IA6BI,qFAKC;IACD,4CAA4C;IAC5C,6BAA6B,EAAA;EApCjC;;;IA6CI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB,EAAA;EAhDvB;IAmDI,gBAAgB;IAChB,UAAU,EAAA;EApDd;IAwDI,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe,EAAA;EA3DnB;IA+DI,eAAe,EAAA;EA/DnB;IAmEI,iBAAiB,EAAA;EAnErB;IAuEI,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,qDAAqD;IACrD,sDAAsD;IACtD,iBAAiB;IACjB,oBAAoB;IACpB,sCAAsC,EAAA;EAhF1C;IAmFI,wBAAwB,EAAA;EAnF5B;IAsFI,mBAAmB;IACnB,iBAAiB;IAEjB,qDAAA,EAAsD;IAzF1D;MA2FM,WAAW;MAAE,kCAAA,EAAmC;IA3FtD;MA+FM,uBAAuB;MAAE,+BAAA,EAAgC;IA/F/D;MAmGM,yBAAyB;MAAE,8BAAA;MAC3B,mBAAmB;MAAE,kCAAA,EAAmC;IApG9D;MAuGM,wBAAwB;MACxB,gCAAgC;MAChC,aAAa;MACb,mBAAmB;MACnB,gBAAgB,EAAA;IA3GtB;MA8GM,uBAAuB;MACvB,iCAAiC;MACjC,uBAAuB;MACvB,sCAAsC;MACtC,kBAAkB;MAClB,uBAAuB,EAAA;MAnH7B;QAsHQ,mBAAmB;QACnB,YAAY;QACZ,cAAc,EAAA;MAxHtB;QA2HQ,2BAA2B;QAC3B,cAAc;QACd,uBAAuB;QACvB,uBAAuB;QACvB,2BAA2B;QAC3B,kBAAkB;QAClB,gBAAgB;QAChB,eAAe;QAEf,uBAAuB;QACvB,sBAAsB,EAAA;QArI9B;UAwIU,wDAGe;UAGf,8BAA2C;UAC3C,uBAAuB;UACvB,kDAA6B;UAC7B,iCAAiC;UACjC,uBAAuB;UAEvB,2CAA2C,EAAA;EApJrD;IA0JI,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,iBAAiB,EAAA;IA9JrB;MAgKM,eAAe;MACf,cAAc,EAAA;EAjKpB;;IAsKI,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IAEf,cAAc,EAAA;EA3KlB;IA8KI,cAAc;IACd,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,4BAA4B;IAC5B,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,kBAAkB,EAAA;IAvLtB;MAyLM,yBAAyB;MACzB,yBAAyB;MACzB,8BAA8B,EAAA;EA3LpC;IA+LI,eAAe;IACf,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB,EAAA;IAvMtB;MAyMM,cAAc,EAAA;IAzMpB;MA4MM,8BAA8B;MAC9B,cAAc,EAAA;IA7MpB;MAgNM,mBAAmB;MACnB,cAAc,EAAA;EAjNpB;IAsNI,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IAEf,cAAc,EAAA;EA3NlB;IA+NI,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IAEf,cAAc,EAAA;IApOlB;MAuOM,aAAa;MACb,kCAAkC;MAClC,gBAAgB;MAChB,eAAe,EAAA;MA1OrB;QA6OQ,iBAAiB,EAAA;IA7OzB;MAkPM,aAAa;MACb,kCAAkC;MAClC,gBAAgB;MAChB,eAAe;MACf,cAAc,EAAA;MAtPpB;QAwPQ,cAAc;QACd,gCAAgC,EAAA;QAzPxC;UA2PU,YAAY,EAAA;;AAOtB;EACE,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe,EAAA;;AAGjB;EACE,cAAc;EACd,gBAAgB;EAChB,6EAA6E;EAC7E,iBAAiB;EACjB,gBAAgB,EAAA;EALlB;IAOI,YAAY,EAAA;;AAIhB;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EAEf,cAAc,EAAA;;AAGhB;EACE,yBAAyB,EAAA;;AAE3B;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EAEf,cAAc;EACd,aAAa;EACb,mBAAmB,EAAA;;AAGrB;EAEE,eAAe,EAAA;;AAGjB;EACE,oCAAoC;EACpC,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB,EAAA;;AAGnB;EACE,mCAAgB;EAChB,uCAAuB;EACvB,uCAAuB,EAAA;;AAGzB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB,EAAA;EAPzB;IAUI,cAAc;IACd,mBAAmB,EAAA;;AAIvB;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;EACE,cAAc,EAAA;;AAGhB;EAEI,uBAAuB;EACvB,eAAe;EACf,UAAU,EAAA;;AAJd;EAOI,yBAAyB;EACzB,eAAe,EAAA;;AARnB;EAWI,sBAAsB;EACtB,8BAA8B;EAC9B,iCAAiC;EACjC,0BAA0B,EAAA","sourcesContent":["@import \"../styles/common.scss\";\n\n.scroll-300 {\n  height: 260px;\n  overflow-y: scroll;\n  font-weight: 400;\n  font-size: 12px;\n\n  color: #9dbcc1;\n}\n\n.scroll-200 {\n  max-height: 200px;\n  overflow-y: scroll;\n}\n\n.dropdown-option {\n  padding: 12px 16px;\n  border-radius: 0.375rem;\n  min-height: 24px;\n  cursor: pointer;\n  &:hover {\n    background-color: grey;\n  }\n}\n\n.modal-90w {\n  --bs-modal-bg: none !important;\n  --bs-modal-border-radius: 30px !important;\n\n  @media screen and (min-width: 576px) {\n    --bs-modal-width: 500px !important;\n  }\n  @media screen and (min-width: 768px) {\n    --bs-modal-width: 550px !important;\n  }\n  @media screen and (min-width: 992px) {\n    --bs-modal-width: 650px !important;\n  }\n  @media screen and (min-width: 1200px) {\n    --bs-modal-width: 775px !important;\n  }\n\n  small {\n    color: #a6c6cc !important;\n  }\n  .error {\n    color: rgba(252, 67, 67, 0.959) !important;\n  }\n  .form-text {\n    font-weight: 400;\n    font-size: 10px;\n  }\n\n  .modal-content {\n    background-image: linear-gradient(\n      to top left,\n      #174454 0%,\n      /* Light Blue */ #192f43 50%,\n      /* Darker Blue */ #27536d 100% /* Light Green */\n    );\n    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.25);\n    font-family: Inter !important;\n    $input-group-addon-bg: #b8f4f6 !important;\n  }\n\n  //--bs-modal-bg: linear-gradient(180deg, #00ffff 0%, #f30808 100%) !important;\n\n  .modal-header,\n  .modal-body,\n  .modal-footer {\n    background: none;\n    border: none;\n    padding-left: 30px;\n    padding-right: 30px;\n  }\n  .container {\n    margin-top: 10px;\n    padding: 0;\n  }\n  //Override bootstrap form styles\n  .form-label {\n    font-family: \"Bai Jamjuree\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n  }\n\n  .form-control {\n    font-size: 14px;\n  }\n\n  input:not([type=\"checkbox\"]):not([type=\"radio\"]) {\n    padding: 6px 15px;\n  }\n\n  .modal-header {\n    font-family: \"Bai Jamjuree\";\n    font-style: normal;\n    font-weight: 500;\n    font-size: 24px;\n    color: #31a6c2;\n    border-top-left-radius: var(--bs-modal-border-radius);\n    border-top-right-radius: var(--bs-modal-border-radius);\n    padding-top: 10px;\n    padding-bottom: 10px;\n    background: rgba(255, 255, 255, 0.034);\n  }\n  .modal-min-height {\n    height: 300px !important;\n  }\n  .modal-body {\n    padding-top: 0.2rem;\n    padding-bottom: 0;\n\n    /* This will affect the entire document's scrollbar */\n    ::-webkit-scrollbar {\n      width: 10px; /* width of the entire scrollbar */\n    }\n\n    ::-webkit-scrollbar-track {\n      background: transparent; /* color of the tracking area */\n    }\n\n    ::-webkit-scrollbar-thumb {\n      background-color: #bcc7c8; /* color of the scroll thumb */\n      border-radius: 20px; /* roundness of the scroll thumb */\n    }\n    .tab-content {\n      height: 300px !important;\n      background: #0c141dab !important;\n      padding: 20px;\n      border-radius: 15px;\n      overflow: hidden;\n    }\n    .tab-group {\n      background: transparent;\n      background-image: none !important;\n      border: none !important;\n      font-family: \"Bai Jamjuree\" !important;\n      font-style: normal;\n      justify-content: center;\n\n      .nav-item {\n        flex-basis: content;\n        flex-grow: 0;\n        margin: 0 10px;\n      }\n      .tab-button {\n        border-radius: 0 !important;\n        display: block;\n        border: none !important;\n        background: transparent;\n        font-family: \"Bai Jamjuree\";\n        font-style: normal;\n        font-weight: 500;\n        font-size: 14px;\n\n        color: white !important;\n        letter-spacing: 0.57px;\n        &.active,\n        &:hover {\n          text-shadow:\n            0 0 1px white,\n            0 0 1px white,\n            0 0 1px white;\n          // font-weight: 400;\n          // letter-spacing: 0;\n          text-shadow: 0px 0px 1px rgb(255, 255, 255);\n          color: white !important;\n          --bs-nav-tabs-link-active-bg: #295f7f00 !important;\n          background-image: none !important;\n          background: transparent;\n\n          border-bottom: 2px solid #44d5cd !important;\n        }\n      }\n    }\n  }\n  .modal-footer {\n    box-sizing: border-box;\n    margin-top: 10px;\n    margin-bottom: 15px;\n    padding-top: 0;\n    padding-bottom: 0;\n    * {\n      margin-right: 0;\n      margin-left: 0;\n    }\n  }\n  .modal-msg,\n  .modal-error-msg {\n    font-family: \"Bai Jamjuree\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 10px;\n\n    color: #587e89;\n  }\n  .close-btn {\n    color: #329aa3;\n    font-family: MyriadPro;\n    letter-spacing: 0.05em;\n    font-weight: 700;\n    font-size: 14px;\n    background: rgba(0, 0, 0, 0);\n    padding: 5px 20px;\n    min-width: 75px;\n    border: 1px solid #329ea0;\n    border-radius: 8px;\n    &:hover {\n      border: 1px solid #3f9a92;\n      color: #3f9a92 !important;\n      background: #303836 !important;\n    }\n  }\n  .confirm-btn {\n    min-width: 75px;\n    font-family: MyriadPro;\n    letter-spacing: 0.05em;\n    font-weight: 700;\n    font-size: 14px;\n    color: #23434b;\n    background: #4bc0d3;\n    padding: 5px 20px;\n    border-radius: 8px;\n    &:enabled {\n      color: #23434b;\n    }\n    &:hover {\n      background: #4bc0d3 !important;\n      color: #fefefe;\n    }\n    &:disabled {\n      background: #5c666f;\n      color: #202932;\n    }\n  }\n\n  .task-fee {\n    font-family: \"Bai Jamjuree\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n\n    color: #9dbcc1;\n  }\n\n  .image-info {\n    font-family: \"Bai Jamjuree\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 12px;\n\n    color: #9dbcc1;\n\n    .info-title {\n      display: grid;\n      grid-template-columns: 1fr 1fr 2fr;\n      font-weight: 400;\n      font-size: 14px;\n\n      .label-text {\n        text-align: start;\n      }\n    }\n\n    .info-row {\n      display: grid;\n      grid-template-columns: 1fr 1fr 2fr;\n      font-weight: 400;\n      font-size: 14px;\n      color: #72e9d9;\n      .address {\n        color: #9dbcc1;\n        transition: all 0.3s ease-in-out;\n        &:hover {\n          color: white;\n        }\n      }\n    }\n  }\n}\n\n.modal-btn {\n  cursor: pointer;\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n}\n\n.logs-btn {\n  color: #23434b;\n  font-weight: 700;\n  background-image: linear-gradient(90deg, #79e3df 0%, #37a0d2 100%) !important;\n  padding: 5px 20px;\n  min-width: 120px;\n  &:hover {\n    color: white;\n  }\n}\n\n.proof-info-label {\n  font-family: \"Bai Jamjuree\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n\n  color: #9dbcc1;\n}\n\n.payment-target {\n  color: #9dbcc1 !important;\n}\n.checkbox-label {\n  font-family: \"Bai Jamjuree\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 10px;\n\n  color: #a6c6cc;\n  display: flex;\n  align-items: center;\n}\n\n.new-proof-checkbox-label {\n  @extend .checkbox-label;\n  font-size: 12px;\n}\n\n.badge {\n  background-color: #2a4953 !important;\n  font-size: 12px;\n  font-weight: 400 !important;\n  margin-left: 5px;\n  margin-right: 5px;\n}\n\n.tooltip {\n  --bs-tooltip-bg: #111c26 !important;\n  --bs-tooltip-padding-y: 10px !important;\n  --bs-tooltip-padding-x: 10px !important;\n}\n\n.topup-button {\n  border: 1px solid #72e9d9;\n  border-radius: 5px;\n  padding: 2px 8px;\n  color: #72e9d9;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &:hover {\n    color: #72e9d9;\n    background: #2f4743;\n  }\n}\n\n.highlight {\n  color: #ffffff;\n  background: #43c0d3;\n  border-radius: 5px;\n}\n\n.reset-btn {\n  color: #8edef5;\n}\n\n.subscription-info {\n  .form-label {\n    color: white !important;\n    font-size: 15px;\n    width: 30%;\n  }\n  .form-text {\n    color: #a6c6cc !important;\n    font-size: 14px;\n  }\n  .form-select {\n    width: auto !important;\n    padding-top: 0.1rem !important;\n    padding-bottom: 0.1rem !important;\n    font-size: 12px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
